import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { PublicHeader } from "./PublicHeader";
import { PublicFooter } from "./PublicFooter";
import { FloatingWhatsAppPublic } from "./CTAWhatsApp";

// Shell público — independente do AdminShell.
// Não exige autenticação; apenas monta header/footer e <Outlet /> das rotas públicas.
export function PublicShell() {
  const location = useLocation();

  // Scroll to top ao navegar entre rotas públicas.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [location.pathname]);

  return (
    <div className="public-shell min-h-screen flex flex-col bg-[#F5F1E8]">
      <PublicHeader />
      <main className="flex-1 pb-24 lg:pb-0">
        <Outlet />
      </main>
      <PublicFooter />
      <FloatingWhatsAppPublic />
    </div>
  );
}
